export function resolvePurchasedLoansListPath(viewerOnly: boolean): string {
  return viewerOnly ? "/loans/list?tab=14" : "/loans/list?tab=0";
}
